import {PipelineStep} from 'pipelines/PipelineTypes';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';
import useOnMount from 'ui-library/hooks/useOnMount';

export const draftStepGlobalState = makeUseGlobalClientState<PipelineStep | null>(null);

export interface UseDraftStepOutput {
  draftStep: PipelineStep | null;
  setDraftStep: (step: PipelineStep) => void;
}

export default function useMaybeDraftStep(
  clientStateId: string,
  initialStep: PipelineStep | null
): UseDraftStepOutput {
  const [draftStep, setDraftStep] = draftStepGlobalState.useGlobalClientState(clientStateId);

  const draftStepOrInitialStep = draftStep ?? initialStep;

  useOnMount(() => {
    if (draftStep == null) {
      setDraftStep(draftStepOrInitialStep);
    }
  });

  return {
    draftStep: draftStepOrInitialStep,
    setDraftStep,
  };
}
